import React from 'react';
import AppLayout from '../components/AppLayout';
import OverviewList from '../components/OverviewList';
import {PageMenu,DeleteListItem,GenerateSpreadsheet,AddListItem,Segment,LoadGraphic,Step,DynamicListArea,BulkEdit,DownloadTemplate} from '../components/Common';
import {EditSizeLabel,EditSizeLink,EditableBox,
        Select,Button,Date,Box,Info,TextButton,
        MiniMinusButton,List,Area} from '../components/Input';
import {} from '../data/Options';
import u from '../utilities/Utilities';
import {Link} from 'react-router-dom';
import {Spreadsheet} from '../data/Mimetypes';
import moment from 'moment';
import store from 'store';
import '../styles/offense-list.scss';

export default class OffenseList extends React.Component{
    r={};

    settings={
        /**** Page Setup ****/
        title:"Merit & Demerit Setup",
        permission:"combined",  //Accepts combined permission module as well
        combinedField:"offense",     //Used when permission exists in a combined field
        url:"/offense-list",

        /**** Action Setup ****/
        addType:0,
        addURL:"/api/add-offense-entry",
        templateURL:"/api/get-add-offense-template",
        bulkURL:"/api/add-bulk-offense",
        deleteURL:"/api/delete-offense-entries",
        spreadsheetURL:"/api/generate-offense-spreadsheet",
        overviewURL:"/api/get-all-offense-entries",

        /**** List Setup ****/
        list:true,
        listLabel:"offense-list",
        orderByField:"label",
        orderByType:"ascending",
        numRows:20,
        checkboxPermissions:{},
        overview:undefined,
        layout:()=>{return this.r['layout']},
        onPopup:(e)=>{this.r['layout'].onPopup(e)},
        onCancelPopup:(e)=>{this.r['layout'].onCancelPopup(e)}
    };

    pageComponents={
        add:{component:AddOffenseEntry,props:{}},
        delete:{component:DeleteListItem,props:{}},
        spreadsheet:{component:GenerateSpreadsheet,props:{}},
        bulkEdit:{component:BulkEdit,props:{}},
    };

    state={
        selected:{
            tags:[],
            all:false,
            data:[],
            entryCount:0
        },
        pageMenuButtons:[],
        permissions:{},
        options:{},
    };

    getOptions=()=>{
        u.post({
            url:"/api/get-options",
            data:{
                keys:["yesNo"],
            },
            success:(options)=>{
                this.setState({options:options});
            },
            error:(error)=>{
                this.setState({error:error});
            }
        });
    }

    componentDidMount=()=>{
        const permissions = u.getPermissions("combined");
        const bulkEditOptions = u.getBulkEdit(this.settings.listLabel);
        const bulkEditEnabled = (bulkEditOptions.length > 0);
        this.setState({
            pageMenuButtons:[
                {label:"Add Entry",ref:"add",enabled:true},
                {label:"Delete Entries",ref:"delete",enabled:true},
                {label:"Generate Spreadsheet",ref:"spreadsheet",enabled:true},
                {label:"Bulk Edit",ref:"bulkEdit",enabled:bulkEditEnabled,padding:"3px"},
            ],
            permissions:permissions,
        });
    }

    onSelectChange=(selected)=>{
        this.setState({selected:selected});
    }

    render=()=>{
        return (
            <AppLayout ref="layout" settings={this.settings}>
                <div className="page-error-container">
                    <div className="page-error">{this.state.error}</div>
                </div>

                <PageMenu buttons={this.state.pageMenuButtons}
                          settings={this.settings}
                          components={this.pageComponents}
                          selected={this.state.selected}/>


                <OverviewList ref={(ref)=>{this.settings.overview=ref}}
                              settings={this.settings}
                              onSelectChange={this.onSelectChange}
                              registerReference={this.registerReference}
                              onMutatedChange={this.onMutatedChange}
                              location={this.props.location}>
                    {
                        (content,index,onChange,onContentChange,registerRef)=>{
                            return (
                                <OffenseItem key={index}
                                              index={index}
                                              content={content}
                                              onChange={onChange}
                                              onContentChange={onContentChange}
                                              registerReference={registerRef}
                                              options={this.state.options}
                                              permissions={this.state.permissions}
                                              />
                            )
                        }
                    }
                </OverviewList>

            </AppLayout>
        )
    }
}

class OffenseItem extends React.Component{
    r={};

    state={
        step:"view",
        error:"",
        loading:false,
        loadText:"",
    };

    onConfirmAdd=()=>{
        this.setState({error:""});

        let newDemerit = this.r['demerits'].validate();
        if(!newDemerit.valid){
            this.setState({error:newDemerit.value});
            return 0;
        }

        let newPenalty=this.r['penalty'].validate();
        if(!newPenalty.valid){
            this.setState({error:newPenalty.value});
            return 0;
        }

        this.setState({loading:true,loadText:"Adding Penalty..."});
        u.post({
            url:"/api/offense-add-penalty",
            data:{
                offenseTypeID:this.props.content.offenseTypeID,
                penalty:newPenalty.value,
                demerits:newDemerit.value,
            },
            success:(penaltyEntry)=>{
                let penalty=this.props.content.penalty;
                penalty.push(penaltyEntry);
                this.props.onChange(penalty,'penalty',this.props.index);
                this.setState({step:"view",error:"",loading:false});
            },
            error:(error)=>{
                this.setState({loading:true,error:error});
            }
        });
    }

    onChangePenalty=(value,label,index)=>{
        let penalty=this.props.content.penalty;
        penalty[index][label]=value;
        this.props.onChange(penalty,"penalty",this.props.index);
    }

    onRemoveRequest=(index)=>{
        this.setState({step:"remove",error:"",removeIndex:index});
    }

    onRemovePenalty=()=>{
        this.setState({loading:true,loadText:"Removing penalty item..."});
        const content=this.props.content;
        u.post({
            url:"/api/offense-remove-penalty",
            data:{
                offenseTypeID:content.offenseTypeID,
                penalty:content.penalty[this.state.removeIndex],
            },
            success:()=>{
                let penalty = content.penalty;
                penalty.splice(this.state.removeIndex,1);
                this.props.onChange(penalty,"penalty",this.props.index);
                this.setState({loading:false,step:"view",error:"",removeIndex:0});
            },
            error:(error)=>{
                this.setState({loading:false,error:error});
            }
        });
    }

    render=()=>{
        const content = this.props.content;
        const infoPlaceholder={width:"15px",height:"15px",marginBottom:"4px"};
        const edit = this.props.permissions.offense;
        return (
            <div>
                <LoadGraphic active={this.state.loading} text={this.state.loadText}/>
                <div className="list-segment-error">{this.state.error}</div>
                <Step active={this.state.step == "view"}>

                    <DynamicListArea content={this.props.content}
                                     onChange={this.props.onChange}
                                     index={this.props.index}
                                     listLabel={"offense-list"}
                                     permission="combined"
                                     combinedField="offense"/>

                    {
                        (content.penalty.length > 0)
                          ?
                          <div className='list-table-container' style={{marginTop:"30px auto"}}>
                              <div>
                                  <h3>Actions <Info style={infoPlaceholder} title="Actions will automatically be assigned to an entry based on occurrence"/></h3>
                              </div>

                              <div className='list-table' style={{maxHeight:"none"}}>
                                  <table>
                                      <thead>
                                          <tr>
                                            <th className="remove left"/>
                                            <th style={{width:"100px"}}>Occurrence</th>
                                            <th>Action</th>
                                            <th style={{width:"100px"}} className="right">Demerits</th>
                                          </tr>
                                      </thead>

                                      <tbody>
                                          {
                                              (content.penalty.length > 0)
                                                  ?
                                                  content.penalty.map((item,index,arr)=>{
                                                      return (
                                                        <tr key={index} className="item">
                                                            <td className="remove">
                                                                <div style={{width:"15px",height:"15px",margin:"auto"}}>
                                                                    <MiniMinusButton enabled={(arr.length > 1)} onClick={()=>{this.onRemoveRequest(index)}}/>
                                                                </div>
                                                            </td>
                                                            <td>{index+1}</td>
                                                            <td>
                                                                <EditableBox label={"Action - " + (index+1)}
                                                                             field="value"
                                                                             index={index}
                                                                             values={{value:item.value,enabled:edit}}
                                                                             rules={{required:true}}
                                                                             id={{offenseTypeID:content.offenseTypeID,entry:item}}
                                                                             url="/api/update-offense-info"
                                                                             onChange={this.onChangePenalty}
                                                                             />
                                                            </td>
                                                            <td>
                                                                <EditableBox label={"Demerit - " + (index+1)}
                                                                             field="demerits"
                                                                             type="number"
                                                                             index={index}
                                                                             values={{value:item.demerits,enabled:edit}}
                                                                             rules={{
                                                                                required:true,
                                                                                minValue:(content.checkType=="Demerit") ? 0 : undefined,
                                                                                maxValue:(content.checkType=="Merit") ? 0 : undefined
                                                                             }}
                                                                             id={{offenseTypeID:content.offenseTypeID,entry:item}}
                                                                             url="/api/update-offense-info"
                                                                             onChange={this.onChangePenalty}
                                                                             />
                                                            </td>
                                                        </tr>
                                                      )
                                                  })
                                                  :
                                                  <div className="list-segment-placeholder">
                                                      No Action Set
                                                  </div>
                                          }
                                      </tbody>
                                  </table>
                              </div>

                              <div style={{textAlign:"center",margin:"20px auto",paddingBottom:"20px"}}>
                              {
                                  (edit && content.penalty.length < 10)
                                      ?
                                      <TextButton onClick={()=>{this.setState({step:"add",error:""})}}>Add Action</TextButton>
                                      :
                                      <div><i>Maximum action entries added (10/10)</i></div>
                              }
                              </div>
                          </div>
                          :
                          <div className="segment-placeholder">
                              No Actions
                              {
                                  (edit)
                                    ?
                                    <div style={{marginTop:"5px"}}>
                                        <TextButton onClick={()=>{this.onCreateLine()}}>Add Action</TextButton>
                                    </div>
                                    :
                                    null
                              }
                          </div>
                    }
                </Step>

                <Step active={this.state.step == "add"}>
                    <div style={{padding:"20px",textAlign:"center",fontSize:"14px"}}>
                        <h3>Add Action</h3>
                        <div>
                            If adding merits, please use a negative number in Demerits column
                        </div>

                        <div>
                            <div className="segment-full-item">
                                <div className="segment-item-label">Demerits:</div>
                                <div className="segment-item-input">
                                    <Box ref={(ref)=>{this.r["demerits"]=ref}}
                                         label="Demerits"
                                         type="number"
                                         rules={{
                                            required:true,
                                            minValue:(content.checkType == "Demerit") ? 0 : undefined,
                                            maxValue:(content.checkType == "Merit") ? 0 : undefined,
                                            defaultValue:0,
                                         }}
                                         />
                                </div>
                            </div>
                            <div className="segment-full-item">
                                <div className="segment-item-label">Action:</div>
                                <div className="segment-item-input">
                                    <Area ref={(ref)=>{this.r["penalty"]=ref}}
                                          label="Penalty"
                                          rules={{
                                            required:true,
                                            placeholder:"Actions are displayed but not enforced by the system"
                                          }}
                                          />
                                </div>
                            </div>
                            <div className="segment-buttons">
                                <Button onClick={()=>{this.setState({step:"view",error:""})}}>Back</Button>
                                <Button onClick={this.onConfirmAdd}>Confirm</Button>
                            </div>
                        </div>

                    </div>
                </Step>

                <Step active={this.state.step == "remove"}>
                    <div style={{padding:"50px",textAlign:"center"}}>
                        {
                            (content.penalty.length > this.state.removeIndex)
                                ?
                                <h2 className="text-negative">Remove Action - {content.penalty[this.state.removeIndex].value}?</h2>
                                :
                                null
                        }
                        <div className="list-segment-note">Note. This action will not affect existing misconduct entries</div>
                        <div className="list-segment-buttons">
                            <Button type="medium" onClick={()=>{this.setState({step:"view",error:""})}}>Back</Button>
                            <Button type="medium" onClick={this.onRemovePenalty}>Confirm</Button>
                        </div>
                    </div>
                </Step>
            </div>
        )
    }
}

class AddOffenseEntry extends React.Component{
    r={};

    state={
        additional:{},
        dormOptions:[],
        entryData:{
            penalty:[
                {}
            ],
        },
        options:{},
        step:"add",
    };

    show=(show)=>{
        this.r[this.props.reference].show(show);
    }

    componentDidMount=()=>{
        this.getDormOptions();
        this.getOptions();
    }

    getOptions=()=>{
        u.post({
            url:"/api/get-options",
            data:{
                keys:["offenseSeverity","offenseCheckType","misconductEntryType","offenseFilterType","offenseFilterCategory","yesNo"],
            },
            success:(options)=>{
                this.setState({options:options});
            },
            error:(error)=>{
                this.setState({error:error});
            }
        });
    }

    getDormOptions=()=>{
        u.post({
            url:"/api/get-estate-options",
            data:{
              type:"dorm"
            },
            success:(dormOptions)=>{
                dormOptions.unshift({value:"all",label:"All Dormitories"});
                this.setState({dormOptions:dormOptions});
            },
            error:(error)=>{
                this.setState({error:error});
            }
        });
    }

    onCancel=()=>{
        this.props.onToggleForm(this.props.reference,false);
    }

    onValidate=()=>{
        this.setState({error:""});
        const entryData=this.state.entryData;
        const keys=["checkType","entryType","dormID","label","severity","filterType","filterCategory","appEnabled"];
        let data={};
        for(var i=0; i<keys.length; i++){
            if(this.r[keys[i]]){
                const current = this.r[keys[i]].validate();
                if(!current.valid){
                    this.setState({error:current.value});
                    return 0;
                }
                data[keys[i]] = current.value;
            }
        }

        for(var j=0; j<entryData.penalty.length; j++){
            const penalty = this.r['p-'+j].validate();
            if(!penalty.valid){
                this.setState({error:penalty.value});
                return 0;
            }
            const demerits = this.r['d-'+j].validate();
            if(!demerits.valid){
                this.setState({error:demerits.value});
                return 0;
            }
        }

        data.penalty = entryData.penalty;

        this.r[this.props.reference].onValidated(data);
    }

    onChange=(value,field,index,option)=>{
        let entryData = this.state.entryData;
        entryData[field] = value;
        if(field == "entryType"){
            if(value != "Resident"){
                entryData.dormID="all";
            }
        }
        this.setState({entryData:entryData});
    }

    onAddPenalty=()=>{
        let entryData=this.state.entryData;
        entryData.penalty.push({});
        this.setState({entryData:entryData});
    }

    onRemovePenalty=(index)=>{
        let entryData=this.state.entryData;
        entryData.penalty.splice(index,1);
        this.setState({entryData:entryData});
    }

    onChangePenalty=(value,label,index)=>{
        let entryData=this.state.entryData;
        entryData.penalty[index][label]=value;
        this.setState({entryData:entryData});
    }

    onComplete=()=>{
        this.setState({
            entryData:{
                penalty:[{}],
            },
            error:"",
        });
    }

    render=()=>{
        const entryData = this.state.entryData;
        const options = this.state.options;
        const infoInput={width:"15px",height:"15px",marginBottom:"3px"};
        const infoPlaceholder={width:"15px",height:"15px",marginBottom:"9px"};

        return(
            <AddListItem ref={(ref)=>{this.r[this.props.reference]=ref}}
                         settings={this.props.settings}
                         reference={this.props.reference}
                         filetypes={Spreadsheet}
                         additional={this.state.additional}
                         onToggleForm={this.props.onToggleForm}
                         onComplete={this.onComplete}>

                <div className="segment-content">
                    <div className="segment-content" style={{textAlign:"center"}}>
                        <h3>Complete the following to continue</h3>

                        <div className="segment-full-item">
                            <div className="segment-item-label">Check Type<Info style={infoInput} title="<b>Demerit</b><br/>Add demerit points to the user<br/><br/><b>Merit</b></br>Add Merit Points to user, to prevent confusion, please use negative numbers<br/><br/><b>Fix Point</b><br/>No matter how many points the user has, set his point to this number"/></div>
                            <div className="segment-item-input"><Select ref={(ref)=>{this.r["checkType"]=ref}} values={{value:entryData.checkType,options:options.offenseCheckType}} label="Check Type" field="checkType" onChange={this.onChange}/></div>
                        </div>

                        <div className="segment-full-item">
                            <div className="segment-item-label">Entry Type<Info style={infoInput} title="Does this merit/demerit apply to Staff or Residents"/></div>
                            <div className="segment-item-input"><Select ref={(ref)=>{this.r["entryType"]=ref}} values={{value:entryData.entryType,options:options.misconductEntryType}} label="Entry Type" field="entryType" onChange={this.onChange}/></div>
                        </div>

                        <div className="segment-full-item">
                            <div className="segment-item-label">Dormitory<Info style={infoInput} title="Offense/Penalty only applies to the selected dormitory"/></div>
                            <div className="segment-item-input"><Select ref={(ref)=>{this.r["dormID"]=ref}} values={{value:entryData.dormID,options:this.state.dormOptions,enabled:entryData.entryType=="Resident"}} label="Dormitory" field="dormID" onChange={this.onChange}/></div>
                        </div>

                        <div className="segment-full-item">
                            <div className="segment-item-label">Severity<Info style={infoInput} title="Classification of the offense, for analytical and categorization purposes"/></div>
                            <div className="segment-item-input"><Select ref={(ref)=>{this.r["severity"]=ref}} values={{value:entryData.severity,options:options.offenseSeverity}} label="Severity" field="severity" onChange={this.onChange}/></div>
                        </div>

                        <div className="segment-full-item">
                            <div className="segment-item-label">App Enabled<Info style={infoInput} title="Can this mert/dermit be assigned on HSB Mobile App"/></div>
                            <div className="segment-item-input"><Select ref={(ref)=>{this.r["appEnabled"]=ref}} values={{value:entryData.appEnabled,options:options.yesNo}} label="App Enabled" field="appEnabled" onChange={this.onChange}/></div>
                        </div>

                        <div className="segment-full-item">
                            <div className="segment-item-label">Filter Type<Info style={infoInput} title="Classification of the offense, for analytical and categorization purposes"/></div>
                            <div className="segment-item-input"><Select ref={(ref)=>{this.r["filterType"]=ref}} values={{value:entryData.filterType,options:options.offenseFilterType}} label="Filter Type" field="filterType" onChange={this.onChange}/></div>
                        </div>

                        <div className="segment-full-item">
                            <div className="segment-item-label">Filter Category<Info style={infoInput} title="Classification of the offense, for analytical and categorization purposes"/></div>
                            <div className="segment-item-input"><Select ref={(ref)=>{this.r["filterCategory"]=ref}} values={{value:entryData.filterCategory,options:options.offenseFilterCategory}} label="Filter Category" field="filterCategory" onChange={this.onChange}/></div>
                        </div>

                        <div className="segment-full-item">
                            <div className="segment-item-label">Offense/Observation <Info style={infoInput} title="Title of the offense or positive observation, such as 'Smoking in non-designated area'"/></div>
                            <div className="segment-item-input">
                                <Box ref={(ref)=>{this.r["label"]=ref}}
                                     values={{value:entryData.label}}
                                     label="Offense"
                                     field="label"
                                     rules={{required:true}}
                                     onChange={this.onChange}
                                     />
                            </div>
                        </div>

                        <div className="segment-full-item">
                            <div className="segment-item-label">Actions <Info style={infoInput} title="Each line represents the action/demerit at the corresponding occurrence. If the offender has more occurrences, it will default to the action at the final line."/></div>
                            <div className="segment-item-input">
                                {
                                    entryData.penalty.map(
                                        (item,index)=>{
                                            return (
                                                <div key={index} className="offense-add-item" style={{marginTop:(index == 0) ? "0" : "5px"}}>
                                                    <div style={{width:"15px",height:"15px",paddingRight:"5px"}}>
                                                        <MiniMinusButton enabled={(index != 0)} onClick={()=>{this.onRemovePenalty(index)}}/>
                                                    </div>
                                                    <div style={{flex:1}}>
                                                        <Box ref={(ref)=>{this.r["p-"+index]=ref}}
                                                             field="value"
                                                             label={"Action " + (index+1)}
                                                             index={(index)}
                                                             values={{value:item.value}}
                                                             onChange={this.onChangePenalty}
                                                             rules={{required:true, placeholder:"Action Description"}}
                                                             />
                                                    </div>
                                                    <div style={{width:"100px",marginLeft:"10px"}}>
                                                        <Box ref={(ref)=>{this.r["d-" + index]=ref}}
                                                             field="demerits"
                                                             label={(entryData.checkType == "Fix Point") ? "Fix Point " + (index+1) : "Demerit " + (index+1)}
                                                             index={(index)}
                                                             onChange={this.onChangePenalty}
                                                             values={{value:item.demerits}}
                                                             type="number"
                                                             rules={{
                                                                required:true,
                                                                placeholder:(entryData.checkType == "Fix Point") ? "Fix Point" : "Demerit Pts",
                                                                minValue:(entryData.checkType == "Demerit") ? 0 : undefined,
                                                                maxValue:(entryData.checkType == "Merit") ? 0 : undefined,
                                                             }}
                                                             />
                                                    </div>
                                                </div>
                                            )
                                        }
                                    )
                                }
                                {
                                    (entryData.penalty.length < 10)
                                        ?
                                        <div style={{textAlign:'right',marginTop:"10px",fontSize:"0.85em"}}>
                                            <TextButton style={{margin:"0"}} onClick={this.onAddPenalty}>Add Action</TextButton>
                                        </div>
                                        :
                                        null
                                }
                            </div>
                        </div>

                        <div style={{margin:"20px auto",fontSize:"14px"}}>
                            For merits please use a negative number for demerit points
                        </div>

                        <div className="segment-buttons">
                            <TextButton style={{margin:"0",fontSize:"14px"}} onClick={()=>{this.r[this.props.reference].onBulkUpload()}}>Upload Spreadsheet</TextButton>
                        </div>

                        <div className="segment-buttons">
                            <div className="segment-error">{this.state.error}</div>
                            {
                                (u.isMobileDevice())
                                    ?
                                    <Button onClick={this.onCancel}>Cancel</Button>
                                    :
                                    null
                            }
                            <Button onClick={this.onValidate}>Create</Button>
                        </div>
                    </div>
                </div>
            </AddListItem>
        )
    }
}
